import zFormCreate from './adapter'
import { bindZorynFormCreate } from './bind-components'

import type { Component } from 'vue'
import type { FieldDefinition } from './types'

export { zFormCreate }

export const FormCreateComponent = zFormCreate.$form()

export function bindFormCreateEngine(fc: {
  component: (name: string, component: Component) => unknown
}) {
  bindZorynFormCreate(fc)
}

export function registerField(
  type: string,
  definition: FieldDefinition | Component
) {
  const component =
    typeof definition === 'object' &&
    definition !== null &&
    'component' in definition
      ? definition.component
      : definition
  zFormCreate.component(type, component as Component)
}

export { zorynFormCreate } from './adapter'
